import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Terminalonetwothreemumbai() {



  const cardData =
  {
    keyword: ' Terminal 1,2,3 Mumbai Airport to Pune Cab',
    heading: 'Sai Trupti Cabs: Terminal 1,2,3 Mumbai Airport to Pune Cab',
    headingDescription: 'Sai Trupti Cabs offers seamless and comfortable transfer services from Chhatrapati Shivaji Maharaj International Airport (Terminals 1, 2 & 3) in Mumbai to your destination in Pune. Whether you arrive at T1 (domestic), T2 (international) or T3, our well-maintained air-conditioned vehicles — including Sedans, SUVs and Premium cars — are available for prompt pickup right at the airport. Each ride is driven by a professional, background-verified chauffeur who monitors your flight arrival and ensures punctual, courteous, and safe service throughout the journey. With transparent pricing (including tolls), flexible one-way or round-trip bookings, and 24×7 customer support, Sai Trupti Cabs makes your Mumbai-to-Pune airport transfer smooth, secure and hassle-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Terminal 1,2,3 Mumbai Airport to Pune Cab",
      "description": "Reliable cab service from Mumbai Airport Terminals 1, 2, and 3 to Pune offering comfortable AC and non-AC vehicles, professional drivers, luggage assistance, flexible pickup and drop locations, real-time tracking, and transparent fares. Perfect for tourists, families, corporate travelers, and business professionals seeking a smooth, safe, and hassle-free journey with multiple vehicle options for groups of all sizes."
    },
    {
      "name": "Mumbai Airport T1-T3 to Pune Taxi",
      "description": "Convenient taxi service from Mumbai Airport Terminals 1 to 3 to Pune with AC/non-AC cars, one-way and round trip options, professional drivers, luggage support, flexible pickup and drop points, real-time tracking, and transparent fares. Ideal for tourists, business travelers, and daily commuters seeking efficient, safe, and reliable transport."
    },
    {
      "name": "Mumbai Airport to Pune Car Hire",
      "description": "Car hire service from Mumbai Airport to Pune offering Sedans, SUVs, and luxury cars with professional drivers, AC/non-AC options, luggage assistance, flexible schedules, real-time tracking, and transparent fares. Perfect for family trips, corporate travel, long-distance commuters, and weekend getaways, ensuring a comfortable, safe, and enjoyable journey."
    },
    {
      "name": "Mumbai Airport T1-T3 to Pune Innova Cab",
      "description": "Spacious Innova cab service from Mumbai Airport Terminals 1-3 to Pune, ideal for families or small groups. Includes AC service, professional drivers, luggage assistance, real-time tracking, flexible pickup/drop points, well-maintained vehicles, and transparent fares, ensuring a smooth, safe, and comfortable journey."
    },
    {
      "name": "Mumbai Airport T1-T3 to Pune Ertiga Cab",
      "description": "Ertiga cab service from Mumbai Airport Terminals 1-3 to Pune providing comfortable seating for groups, AC service, luggage support, professional drivers, real-time tracking, and flexible pickup/drop locations. Perfect for tourists, families, and corporate travelers seeking a reliable and stress-free ride."
    },
    {
      "name": "Mumbai Airport to Pune Sedan Cab",
      "description": "Sedan cab service from Mumbai Airport to Pune offering smooth, comfortable rides for solo travelers, couples, or small families. Features AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop locations, real-time tracking, and transparent fares. Ideal for business commuters, tourists, and city-to-city travelers seeking convenient and reliable transport."
    },
    {
      "name": "Mumbai Airport T1-T3 to Pune One Way Taxi",
      "description": "Affordable one-way taxi service from Mumbai Airport Terminals 1-3 to Pune, ideal for travelers seeking direct, efficient, and hassle-free transport. Includes AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, real-time tracking, and transparent fares. Suitable for tourists, business travelers, and daily commuters."
    },
    {
      "name": "Mumbai Airport to Pune Drop Cab",
      "description": "Drop cab service from Mumbai Airport to Pune providing point-to-point travel with AC cars, professional drivers, luggage support, flexible pickup/drop locations, real-time tracking, well-maintained vehicles, and transparent fares. Perfect for daily commuters, corporate travelers, and tourists seeking a convenient, reliable, and comfortable ride."
    },
    {
      "name": "Mumbai Airport to Pune Luxury Cab",
      "description": "Premium luxury cab service from Mumbai Airport to Pune with high-end vehicles, AC service, elegant interiors, professional chauffeurs, luggage support, flexible schedules, real-time tracking, and transparent fares. Ideal for executives, VIP travelers, families, and couples seeking a stylish, comfortable, and high-end travel experience."
    },
    {
      "name": "Mumbai Airport to Pune Outstation Cab",
      "description": "Outstation cab service from Mumbai Airport to Pune with AC/non-AC options, professional drivers, luggage assistance, toll coverage, flexible schedules, online booking, well-maintained vehicles, and transparent fares. Perfect for long-distance commuters, weekend trips, and corporate travel, ensuring a safe, comfortable, and hassle-free journey."
    },
    {
      "name": "Affordable Mumbai Airport T1-T3 to Pune Cab",
      "description": "Budget-friendly cab service from Mumbai Airport Terminals 1-3 to Pune providing cost-effective rides without compromising safety, comfort, or reliability. Features AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop locations, real-time tracking, and transparent fares. Ideal for students, families, tourists, and cost-conscious travelers."
    },
    {
      "name": "Mumbai Airport to Pune AC Cab",
      "description": "AC cab service from Mumbai Airport to Pune offering cool, comfortable, and safe rides for families, corporate travelers, tourists, and daily commuters. Includes professional drivers, luggage support, flexible schedules, real-time tracking, well-maintained vehicles, online booking, and transparent fares."
    },
    {
      "name": "Mumbai Airport to Pune Online Booking",
      "description": "Book your Mumbai Airport to Pune cab online instantly with multiple vehicle options including Sedans, SUVs, and luxury cars. Features secure payments, real-time tracking, AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop locations, and transparent fares. Ideal for corporate travelers, tourists, and daily commuters seeking a convenient and reliable service."
    },
    {
      "name": "Mumbai Airport to Pune Travel Service",
      "description": "Comprehensive travel service from Mumbai Airport to Pune including one-way and round trips, drop services, and luxury options. Features AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, online booking, real-time tracking, and transparent fares. Ensures a safe, comfortable, and convenient journey for families, corporate travelers, tourists, and daily commuters."
    },
    {
      "name": "Mumbai Airport to Pune Cab Near Me",
      "description": "Find Mumbai Airport to Pune cabs near your location for quick, convenient, and hassle-free booking. Includes AC and non-AC vehicles, professional drivers, luggage support, real-time tracking, flexible schedules, transparent fares, well-maintained vehicles, and reliable service for daily, occasional, or emergency travel needs."
    }
  ],
  "tableData": [
    ["Terminal 1,2,3 Mumbai Airport to Pune Cab", "Mumbai Airport T1-T3 to Pune Taxi"],
    ["Mumbai Airport to Pune Car Hire", "Mumbai Airport T1-T3 to Pune Innova Cab"],
    ["Mumbai Airport T1-T3 to Pune Ertiga Cab", "Mumbai Airport to Pune Sedan Cab"],
    ["Mumbai Airport T1-T3 to Pune One Way Taxi", "Mumbai Airport to Pune Drop Cab"],
    ["Mumbai Airport to Pune Luxury Cab", "Mumbai Airport to Pune Outstation Cab"],
    ["Affordable Mumbai Airport T1-T3 to Pune Cab", "Mumbai Airport to Pune AC Cab"],
    ["Mumbai Airport to Pune Online Booking", "Mumbai Airport to Pune Travel Service"],
    ["Mumbai Airport to Pune Cab Near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Terminal 1, 2, 3 Mumbai Airport to Pune Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd provides reliable and comfortable cab services from Mumbai Airport (Terminals 1, 2 or 3) to Pune—ideal for airport pickups, business trips or leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one‑way fares from Mumbai Airport to Pune start from approximately ₹1,849 for a hatchback and around ₹2,600–₹3,700 for sedans and SUVs, with tolls and state tax included. :contentReference[oaicite:turn0search8]{index=1} :contentReference[oaicite:turn0search5]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the airport → Pune route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Mumbai Airport → Pune route and ensure a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer pickup right from Mumbai Airport (Terminals T1, T2 or T3) and drop‑off at any location in Pune—including hotels, railway stations, airports or your residence."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized and maintained to ensure comfort and reliability for your inter‑city ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, flight schedule changes, route planning or any travel assistance."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Mumbai Airport to Pune cab easily via call, WhatsApp or our website—with instant confirmation and prompt dispatch."
  }
]

































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer cab services from Mumbai Airport Terminals 1, 2, 3 to Pune?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable cab services from Mumbai Airport (Terminals 1, 2, and 3) to Pune for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a cab from Mumbai Airport to Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your cab from Mumbai Airport to Pune through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Mumbai Airport to Pune?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Mumbai Airport to Pune trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in airport transfers and long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Mumbai Airport to Pune for corporate or personal travel?',
    answer: 'Certainly. Our cab services cater to corporate clients, airport transfers, meetings, and personal travel from Mumbai Airport to Pune.',
  },
  {
    question: 'Is the Mumbai Airport to Pune cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Mumbai Airport to Pune trips for maximum convenience and travel flexibility.',
  },
  {
    question: 'What are the Mumbai Airport to Pune cab fares?',
    answer: 'Our cab fares start from approximately ₹1,800 for sedans, ₹2,500–₹3,500 for SUVs and premium vehicles, depending on vehicle type, distance, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Mumbai Airport to Pune cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Mumbai Airport to Pune cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Mumbai Airport to Pune cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Mumbai Airport to Pune cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshmukh',
    feedback: 'I booked a cab from Mumbai Airport to Pune with Sai Trupti Cabs. The driver was professional, and the ride was very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Patil',
    feedback: 'Sai Trupti Cabs provided excellent service from Mumbai Airport to Pune. Smooth and punctual journey with courteous driver.',
    rating: 5,
  },
];










































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Terminal 1,2,3 Mumbai Airport to Pune Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Terminal 1,2,3 Mumbai Airport to Pune Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/mumbai-airport-to-pune-cab"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Terminal 1,2,3 Mumbai Airport to Pune Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Terminal 1,2,3 Mumbai Airport to Pune Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Terminal 1,2,3 Mumbai Airport to Pune Cab, Mumbai Airport T1-T3 to Pune Taxi, Mumbai Airport to Pune Car Hire, Mumbai Airport T1-T3 to Pune Innova Cab, Mumbai Airport T1-T3 to Pune Ertiga Cab, Mumbai Airport to Pune Sedan Cab, Mumbai Airport T1-T3 to Pune One Way Taxi, Mumbai Airport to Pune Drop Cab, Mumbai Airport to Pune Luxury Cab, Mumbai Airport to Pune Outstation Cab, Affordable Mumbai Airport T1-T3 to Pune Cab, Mumbai Airport to Pune AC Cab, Mumbai Airport to Pune Online Booking, Mumbai Airport to Pune Travel Service, Mumbai Airport to Pune Cab Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newkey/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Terminalonetwothreemumbai;